export type FefoLotRow = {
  id: string;
  remaining_quantity: number;
  unit_cost: number;
  expires_at: string | null;
};

export type FefoLotAllocation = {
  lotId: string;
  quantity: number;
  unitCost: number;
  expiresAt: string | null;
};

/** Orden FEFO: expires_at ASC NULLS LAST (los lotes ya vienen ordenados desde SQL). */
export const allocateLotsByFefoOrder = (
  lots: FefoLotRow[],
  quantityNeeded: number
): FefoLotAllocation[] => {
  if (lots.length === 0 || quantityNeeded <= 0) return [];

  const allocations: FefoLotAllocation[] = [];
  let remaining = quantityNeeded;

  for (const lot of lots) {
    if (remaining <= 0) break;
    const take = Math.min(remaining, lot.remaining_quantity);
    if (take <= 0) continue;
    allocations.push({
      lotId: lot.id,
      quantity: take,
      unitCost: lot.unit_cost,
      expiresAt: lot.expires_at,
    });
    remaining -= take;
  }

  return allocations;
};
